import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const goldAndSliverSellApi = createAsyncThunk(
  "goldAndSilverSell",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/augmont/sell-gold-silver`,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  data: [],
  errors: [],
  status: "idle",
};

const goldAndSilverSellSlice = createSlice({
  name: "goldAndSilverSell",
  initialState,
  reducers: {
    resetState: (state) => {
      return initialState; // Reset state to initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(goldAndSliverSellApi.pending, (state) => {
        state.status = "loading";
        state.errors = [];
      })
      .addCase(goldAndSliverSellApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "idle";
      })
      .addCase(goldAndSliverSellApi.rejected, (state, action) => {
        state.errors.push(action.payload);
        state.status = "idle";
      });
  },
});

export const { resetState } = goldAndSilverSellSlice.actions;

export default goldAndSilverSellSlice.reducer;
